/* @flow */
import React from 'react';

import Button from 'components/Button.jsx';
import Chat from 'entities/Chat';
import ChatActions from 'chat/actions/ChatActions';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Glyph from 'components/Glyph.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';

class LeaveChatButton extends React.Component {
  static propTypes = {
    chat: React.PropTypes.instanceOf(Chat).isRequired,
    buttonClassName: React.PropTypes.string,
  };

  renderLeaveButton() {
    const { chat } = this.props;

    const pauseModal = (
      <ConfirmDialog
        eventScreenName="LeaveChatButton"
        glyph="caution"
        glyphColor="lava"
        title="Leave this conversation?"
        subtext="You won’t receive new messages in this conversation."
        onConfirm={() => ChatActions.leaveChat(chat)}
      />
    );

    return (
      <ModalTrigger modal={pauseModal}>
        <Button
          className={this.props.buttonClassName}
          level="text"
          color="lava">
          <Glyph name="close" />
          Leave this conversation
        </Button>
      </ModalTrigger>
    );
  }

  render() {
    const { chat } = this.props;

    if (!chat.canLeave()) {
      return null;
    }

    return (
      <div className="LeaveChatButton">
        {this.renderLeaveButton()}
      </div>
    );
  }
}

export default LeaveChatButton;



// WEBPACK FOOTER //
// ./src/chat/components/LeaveChatButton.jsx